<template>
    <div v-if="goodDetail" class="good-detail">
        <div class="banner">
            <div class="banner-main" @click="openImageView()">
                <swiper ref="swiperMain" :options="swiperMainOption">
                    <swiper-slide v-for="(item, index) in goodDetail.thumb_arr" :key="index">
                        <a :style="`background: url('${item}')`"></a>
                    </swiper-slide>
                    <div slot="pagination" class="swiper-pagination"></div>
                </swiper>
            </div>
            <div v-if="goodDetail.thumb_arr && goodDetail.thumb_arr.length > 2" class="banner-secondary">
                <swiper ref="swiperSecondary" :options="swiperSecondaryOption">
                    <swiper-slide v-for="(item, index) in goodDetail.thumb_arr" :key="index">
                        <a :style="`background: url('${item}')`"></a>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
        <div class="good-info">
            <div class="info-top">
                <div class="item-word">
                    <p>
                        <b>产品名称：</b>
                        <b>{{ goodDetail.title }}</b>
                    </p>
                    <p>
                        <b>价<i class="transparent">占占</i>格：</b>
                        <b class="red" v-if="goodDetail.price">
                            <template v-if="goodDetail.children && goodDetail.children.length > 0"
                                >￥{{ minPrice }} ~ {{ maxPrice }}</template
                            >
                            <template v-else>￥{{ goodDetail.price }}</template>
                        </b>
                        <b v-else class="red">暂无报价</b>
                        <span class="grey">{{ goodDetail.subtitle }}</span>
                    </p>
                </div>
                <a v-if="app.userData.roles?.is_designer" class="item-button" @click="openChooseDialog()">加入购物车</a>
            </div>
        </div>
        <div v-if="goodDetail.children && goodDetail.children.length > 0" class="good-richtext">
            <p class="item-title">产品列表</p>
            <div class="item-table">
                <p class="table-title">
                    <span>名称</span>
                    <span>规格</span>
                    <span>单价</span>
                </p>
                <p v-for="(item, index) in goodDetail.children" class="table-content">
                    <span>{{ item.title }}</span>
                    <template v-for="(citem, cindex) in item.parameter_form">
                        <span v-if="citem.name === '规格'">{{ citem.value }}</span>
                    </template>
                    <span>￥{{ item.price }}</span>
                </p>
            </div>
        </div>

        <div class="good-richtext">
            <div class="tab-container" :class="{ 'tab-fixed': isTabFixed }">
                <div class="tab-header" :class="{ fixed: isTabFixed }">
                    <template v-for="(tab, index) in tabList">
                        <div
                            :key="`tab-${tab.key}`"
                            class="tab-item"
                            :class="{ active: activeTab === tab.key }"
                            @click="switchTab(tab.key)"
                        >
                            {{ tab.label }}
                        </div>
                        <div v-if="index < tabList.length - 1" :key="`divider-${tab.key}`" class="tab-divider"></div>
                    </template>
                </div>
                <div class="tab-content">
                    <div ref="specContent" class="tab-panel" v-show="activeTab === 'spec'">
                        <p class="item-title">产品规格</p>
                        <div class="item-content">
                            <div class="spec-list">
                                <p v-for="(item, index) in goodDetail.parameter_form" :key="index" class="spec-item">
                                    <b>{{ item.name }}：</b>
                                    <b>{{ item.value }}</b>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div ref="infoContent" class="tab-panel" v-show="activeTab === 'info'">
                        <!-- <p class="item-title">产品信息</p> -->
                        <div class="item-content" v-html="goodDetail.content"></div>
                    </div>
                    <!-- 买家秀模块暂时注释 -->
                    <!-- <div ref="buyerShowContent" class="tab-panel" v-show="activeTab === 'buyerShow'">
                        <p class="item-title">买家秀（{{ buyerShowsTotal }}）</p>
                        <div class="item-content">
                            <div class="buyer-show-tab-content">
                                <div v-if="buyerShows.length > 0" class="show-items">
                                    <div
                                        v-for="(show, index) in buyerShows"
                                        :key="index"
                                        class="show-item"
                                        @click="viewShowDetail(show)"
                                    >
                                        <div
                                            class="media-content"
                                            v-if="(show.images && show.images.length > 0) || show.video"
                                        >
                                            <div
                                                v-if="show.video"
                                                class="media-item video-item"
                                                @click.stop="playVideo(show.video)"
                                            >
                                                <video
                                                    :src="getFullVideoUrl(show.video)"
                                                    :poster="
                                                        show.images && show.images.length > 0
                                                            ? getFullImageUrl(show.images[0])
                                                            : ''
                                                    "
                                                    controls
                                                    preload="metadata"
                                                    class="video-player"
                                                >
                                                    您的浏览器不支持视频播放
                                                </video>
                                                <div class="media-badge">
                                                    <van-icon name="play-circle-o" size="16" />
                                                    视频
                                                </div>
                                            </div>

                                            <div
                                                v-if="show.images && show.images.length > 0"
                                                v-for="(image, imgIndex) in show.images"
                                                :key="imgIndex"
                                                class="media-item image-item"
                                                @click.stop="previewImage(show.images, imgIndex)"
                                            >
                                                <img :src="getFullImageUrl(image)" :alt="'买家秀图片'" />
                                                <div class="media-badge">{{ imgIndex + 1 }}/{{ show.images.length }}</div>
                                            </div>
                                        </div>

                                        <div class="user-info">
                                            <div class="avatar">
                                                <img
                                                    :src="`https://heimg.demo.qoomoe.com/${show.user?.avatar}`"
                                                    :alt="show.user?.nickname"
                                                />
                                            </div>
                                            <div class="user-details">
                                                <div class="user-name">{{ show.user?.nickname || "匿名用户" }}</div>
                                                <div class="show-time" v-if="show.created_at">
                                                    {{ formatTime(show.created_at) }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="show-text" v-if="show.content">{{ show.content }}</div>
                                    </div>
                                </div>

                                <div v-else-if="!buyerShowLoading" class="empty-state">
                                    <div class="empty-icon">📷</div>
                                    <div class="empty-text">暂无买家秀</div>
                                </div>

                                <div v-if="buyerShowHasMore && !buyerShowLoading" class="load-more" @click="loadMoreBuyerShows">
                                    <span>加载更多</span>
                                </div>

                                <div v-if="buyerShowLoading" class="loading">
                                    <van-loading type="spinner" size="20px">加载中...</van-loading>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <!--选择商品规格弹窗-->
        <van-dialog v-model="chooseDialog.visible" :closeOnClickOverlay="true" :showConfirmButton="false">
            <div class="choose-dialog">
                <div class="item-top">
                    <p class="p1">请选择你要的商品：</p>
                    <p class="p2">{{ goodDetail.bar_code }}</p>
                    <p class="p3">
                        <span>选择</span>
                        <span class="red">￥{{ totalPrice }}</span>
                    </p>
                </div>
                <div class="item-middle">
                    <div class="list-wrapper">
                        <div v-for="(item, index) in goodDetail.children" v-if="item.on_sale === 1" class="list-item">
                            <a class="item-name">{{ item.sub_title }}</a>
                            <div class="item-count">
                                <van-stepper v-model="item.count" min="0" @change="countChange()" />
                            </div>
                            <p class="item-price">￥{{ item.price }}</p>
                        </div>
                    </div>
                </div>
                <div class="item-bottom">
                    <van-button block class="item-button" color="#F54A4A" type="primary" @click="addGood()"
                        >加入购物车
                    </van-button>
                </div>
            </div>
        </van-dialog>
        <!--成功加入购物车弹窗-->
        <van-dialog v-model="addSuccessDialog.visible" :closeOnClickOverlay="true" :showConfirmButton="false">
            <div class="add-success-dialog">
                <div :style="`background: url('${goodDetail.thumb}')`" class="item-image"></div>
                <div class="item-title">
                    <p class="title-left">
                        {{ goodDetail.title }}
                    </p>
                    <p class="title-right">
                        <van-icon name="checked" />
                        <span>已加入购物车</span>
                    </p>
                </div>
                <div class="item-info">
                    <p>
                        <span>小计：</span>
                        <span class="s1">{{ goodDetail.price }}元</span>
                    </p>
                </div>
                <div class="item-button">
                    <van-button block class="item-button" color="#F54A4A" to="/shop-cart" type="primary"
                        >去购物车结算
                    </van-button>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// 引入mixins
import mixins_config from "@/mixins/config";
// 引入接口
import { ADD_CARTS, GOODS_DETAIL, GET_BUYER_SHOW } from "@/api/dataProvider.js";
// 引入图片预览
import { ImagePreview } from "vant";
import wx from "weixin-js-sdk";

// 给swiper用
let vm = null;

export default {
    name: "GoodDetail",
    mixins: [mixins_config],
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            // 商品详情
            goodDetail: {},
            // 总价
            totalPrice: 0,
            minPrice: 0,
            maxPrice: 0,
            // 轮播图
            swiperMainOption: {
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction"
                },
                on: {
                    slideChange: function () {
                        vm.$refs.swiperSecondary.swiper.slideTo(this.activeIndex, 500, false);
                    }
                }
            },
            swiperSecondaryOption: {
                slidesPerView: 3,
                spaceBetween: 10,
                slideToClickedSlide: true,
                on: {
                    click: function () {
                        vm.$refs.swiperMain.swiper.slideTo(this.clickedIndex, 500, false);
                    }
                }
            },
            // 选择单品弹窗
            chooseDialog: {
                visible: false
            },
            // 成功加入购物车弹窗
            addSuccessDialog: {
                visible: false
            },
            // 当前激活的tab
            activeTab: "spec",
            // tab列表配置
            tabList: [
                {
                    key: "spec",
                    label: "产品规格",
                    ref: "specContent"
                },
                {
                    key: "info",
                    label: "产品信息",
                    ref: "infoContent"
                },
                // {
                //     key: "buyerShow",
                //     label: "买家秀",
                //     ref: "buyerShowContent"
                // }
            ],
            // tab是否固定在顶部
            isTabFixed: false,
            // tab容器的位置信息
            tabContainerTop: 0,
            // 买家秀数据
            buyerShows: [],
            // 买家秀总数
            buyerShowsTotal: 0,
            // 买家秀分页数据
            buyerShowPage: 1,
            buyerShowPageSize: 10,
            buyerShowHasMore: true,
            buyerShowLoading: false
        };
    },
    computed: {
        // 合并所有买家秀的图片
        allImages() {
            const images = [];
            this.buyerShows.forEach((show) => {
                if (show.images && show.images.length > 0) {
                    // 为每个图片URL拼接域名
                    const fullImages = show.images.map((img) => {
                        if (img.startsWith("http")) {
                            return img; // 如果已经是完整URL，直接返回
                        } else {
                            return `https://heimg.demo.qoomoe.com/${img}`;
                        }
                    });
                    images.push(...fullImages);
                }
            });
            return images;
        }
    },
    watch: {
        goodDetail: {
            handler(newVal) {
                if (newVal && newVal.title) {
                    // 向小程序发送商品信息
                    if (wx && wx.miniProgram) {
                        wx.miniProgram.postMessage({
                            data: {
                                type: "shareInfo",
                                title: newVal.title,
                                desc: newVal.subtitle || "",
                                imageUrl: newVal.thumb,
                                path: `/pages/index/index?url=${encodeURIComponent(
                                    `${window.location.origin}/#/good/${this.$route.params.id}`
                                )}`
                            }
                        });
                    }
                }
            },
            immediate: true
        }
    },
    created() {
        vm = this;
        this.app.tabActive = 1;
    },
    mounted() {
        this.getPid().then(() => {
            this.getGoodDetail();
        });
        // 买家秀暂时注释
        // this.getBuyerShows();
        // 添加滚动监听
        window.addEventListener("scroll", this.handleScroll);
        // 获取tab容器位置
        this.getTabContainerPosition();
    },
    beforeDestroy() {
        // 移除滚动监听
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        // 打开图片预览
        openImageView() {
            ImagePreview({
                images: this.goodDetail.thumb_arr,
                closeable: true
            });
        },
        // 获取父商品PID
        getPid() {
            return new Promise((resolve) => {
                GOODS_DETAIL(
                    {
                        id: this.$route.params.id
                    },
                    (res) => {
                        if (res.data.data.data.pid > 0) {
                            // 子类跳父类
                            // this.$router.push({
                            //     name: "GoodDetail",
                            //     params: {
                            //         id: res.data.data.data.pid
                            //     }
                            // })
                        }
                        resolve();
                    }
                );
            });
        },
        // 获取商品列表
        getGoodDetail() {
            GOODS_DETAIL(
                {
                    id: this.$route.params.id
                },
                (res) => {
                    this.goodDetail = res.data.data.data;
                    if (this.goodDetail.children && this.goodDetail.children.length > 0) {
                        let priceArr = [];
                        let imgArr = [];
                        this.goodDetail.children.map((item) => {
                            item.count = 0;
                            priceArr.push(item.price);
                            imgArr = imgArr.concat(item.thumb_arr);
                        });
                        this.goodDetail.thumb_arr = this.goodDetail.thumb_arr.concat(imgArr);
                        console.log(this.goodDetail.thumb_arr);
                        this.minPrice = Math.min(...priceArr);
                        this.maxPrice = Math.max(...priceArr);
                    }
                    // 数据加载完成后重新获取tab容器位置
                    this.$nextTick(() => {
                        this.getTabContainerPosition();
                    });
                }
            );
        },
        // 打开选择单品弹窗
        openChooseDialog() {
            if (this.goodDetail.children && this.goodDetail.children.length > 0) {
                this.chooseDialog.visible = true;
            } else {
                ADD_CARTS(
                    {
                        cargos: [
                            {
                                id: this.goodDetail.id,
                                count: 1
                            }
                        ]
                    },
                    (res) => {
                        if (res.data.code == 0) {
                            this.$notify({ type: "success", message: "加入成功！" });
                            this.getGoodDetail();
                        } else {
                            this.$notify({ type: "danger", message: "加入失败，请重试！" });
                        }
                    }
                );
            }
        },
        // 获取弹窗价格
        getAllPrice(arr) {
            let price = 0;
            arr.map((item) => {
                price += Number(item.price * item.count);
            });
            this.totalPrice = price;
        },
        // 更新价格
        countChange() {
            let priceArr = this.goodDetail.children.filter((item) => {
                return item.count > 0;
            });
            this.getAllPrice(priceArr);
        },
        // 添加到购物车
        addGood() {
            let goodsArr = [];

            this.goodDetail.children.map((item) => {
                if (item.count > 0) {
                    goodsArr.push({
                        id: item.id,
                        count: item.count
                    });
                }
            });

            this.chooseDialog.visible = false;

            ADD_CARTS(
                {
                    cargos: goodsArr
                },
                (res) => {
                    if (res.data.code == 0) {
                        this.$notify({ type: "success", message: "加入成功！" });
                        this.getGoodDetail();
                    } else {
                        this.$notify({ type: "danger", message: "加入失败，请重试！" });
                    }
                }
            );
        },
        // 切换tab
        switchTab(tab) {
            this.activeTab = tab;
            const currentTab = this.tabList.find((item) => item.key === tab);
            if (currentTab && this.$refs[currentTab.ref]) {
                this.$nextTick(() => {
                    const element = this.$refs[currentTab.ref];
                    const rect = element.getBoundingClientRect();
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const tabHeight = this.isTabFixed ? 44 : 0; // tab固定时的高度
                    const offset = rect.top + scrollTop - tabHeight - 20; // 减去tab高度和一些间距

                    window.scrollTo({
                        top: Math.max(0, offset), // 确保不会滚动到负值
                        behavior: "smooth"
                    });
                });
            }
        },
        // 处理滚动事件
        handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.isTabFixed = scrollTop >= this.tabContainerTop;
        },
        // 获取tab容器位置
        getTabContainerPosition() {
            this.$nextTick(() => {
                const tabContainer = document.querySelector(".tab-container");
                if (tabContainer) {
                    this.tabContainerTop = tabContainer.offsetTop;
                }
            });
        },
        // 获取买家秀数据
        getBuyerShows(isLoadMore = false) {
            if (this.buyerShowLoading) return;

            this.buyerShowLoading = true;

            GET_BUYER_SHOW(
                {
                    cargo_id: this.$route.params.id,
                    page: this.buyerShowPage
                },
                (res) => {
                    this.buyerShowLoading = false;

                    if (res.data.code === 0) {
                        const newData = res.data.data.data || [];
                        const total = res.data.data.total || 0;

                        if (isLoadMore) {
                            this.buyerShows = [...this.buyerShows, ...newData];
                        } else {
                            this.buyerShows = newData;
                        }

                        this.buyerShowsTotal = total;
                        // 判断是否还有更多数据
                        this.buyerShowHasMore = this.buyerShows.length < total;
                    } else {
                        this.$notify({ type: "danger", message: "获取买家秀失败" });
                    }
                }
            );
        },
        // 查看全部买家秀
        viewAllShows() {
            this.$router.push({
                name: "BuyerShow",
                params: { id: this.$route.params.id }
            });
        },
        // 加载更多买家秀
        loadMoreBuyerShows() {
            if (this.buyerShowHasMore && !this.buyerShowLoading) {
                this.buyerShowPage++;
                this.getBuyerShows(true);
            }
        },
        // 获取完整图片URL
        getFullImageUrl(imageUrl) {
            if (!imageUrl) return "";
            if (imageUrl.startsWith("http")) {
                return imageUrl;
            } else {
                return `https://heimg.demo.qoomoe.com/${imageUrl}`;
            }
        },
        // 获取完整视频URL
        getFullVideoUrl(videoUrl) {
            if (!videoUrl) return "";
            if (videoUrl.startsWith("http")) {
                return videoUrl;
            } else {
                return `https://heimg.demo.qoomoe.com/${videoUrl}`;
            }
        },
        // 播放视频
        playVideo(videoUrl) {
            const fullVideoUrl = this.getFullVideoUrl(videoUrl);
            if (fullVideoUrl) {
                // 可以在这里添加视频播放逻辑，比如打开一个视频播放器弹窗
                console.log("播放视频:", fullVideoUrl);
            }
        },
        // 预览图片
        previewImage(images, currentIndex) {
            const fullImages = images.map((img) => this.getFullImageUrl(img));
            ImagePreview({
                images: fullImages,
                startPosition: currentIndex,
                closeable: true
            });
        },
        // 查看买家秀详情
        viewShowDetail(show) {
            // 如果有视频，优先播放视频
            if (show.video) {
                this.playVideo(show.video);
            }
            // 如果有图片，预览第一张图片
            else if (show.images && show.images.length > 0) {
                this.previewImage(show.images, 0);
            }
        },
        // 格式化时间
        formatTime(timestamp) {
            if (!timestamp) return "";

            // 如果是字符串格式的时间戳，先转换为数字
            let time = timestamp;
            if (typeof timestamp === "string") {
                // 如果是ISO格式的时间字符串
                if (timestamp.includes("T") || timestamp.includes("-")) {
                    time = new Date(timestamp).getTime();
                } else {
                    // 如果是数字字符串
                    time = parseInt(timestamp) * 1000;
                }
            } else {
                time = timestamp * 1000;
            }

            const date = new Date(time);
            const now = new Date();
            const diff = now - date;

            // 小于1分钟
            if (diff < 60000) {
                return "刚刚";
            }
            // 小于1小时
            if (diff < 3600000) {
                return `${Math.floor(diff / 60000)}分钟前`;
            }
            // 小于24小时
            if (diff < 86400000) {
                return `${Math.floor(diff / 3600000)}小时前`;
            }
            // 小于30天
            if (diff < 2592000000) {
                return `${Math.floor(diff / 86400000)}天前`;
            }

            // 超过30天显示具体日期
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
                date.getDate()
            ).padStart(2, "0")}`;
        }
    }
};
</script>

<style lang="scss">
.good-detail {
    padding: 0 0 50px 0;
    background: #f5f5f5;

    .banner {
        background: #ffffff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        .banner-main {
            width: 100%;
            height: 264px;

            .swiper-container {
                width: 100%;
                height: 100%;

                .swiper-wrapper {
                    width: 100%;
                    height: 100%;

                    .swiper-slide {
                        width: 100%;
                        height: 100%;

                        a {
                            display: block;
                            width: 100%;
                            height: 100%;
                            background-repeat: no-repeat !important;
                            background-size: contain !important;
                            background-position: center !important;
                        }
                    }
                }
            }
        }

        .banner-secondary {
            width: calc(100% - 40px);
            height: 70px;
            margin: 20px auto 0 auto;

            .swiper-container {
                width: 100%;
                height: 100%;

                .swiper-wrapper {
                    width: 100%;
                    height: 100%;

                    .swiper-slide {
                        a {
                            display: block;
                            width: 100%;
                            height: 60px;
                            background-repeat: no-repeat !important;
                            background-size: cover !important;
                            background-position: center !important;
                        }
                    }
                }
            }
        }
    }

    .good-info {
        background: #ffffff;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        .info-top {
            display: flex;
            align-items: center;

            .item-word {
                width: 250px;

                p {
                    margin-bottom: 15px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    b,
                    span {
                        margin-right: 10px;
                        font-size: 10px;
                        color: #2d2d2d;
                    }

                    .transparent {
                        opacity: 0;
                    }

                    .red {
                        color: #f54a4a;
                    }

                    .grey {
                        color: #999999;
                    }
                }
            }

            .item-button {
                width: 69px;
                height: 28px;
                line-height: 28px;
                margin-left: auto;
                background: #f54a4a;
                border-radius: 3px;
                text-align: center;
                font-size: 10px;
                color: #fff;
            }
        }
    }



    .good-richtext {
        margin-top: 16px;

        .tab-container {
            background: #ffffff;
            padding-bottom: 16px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

            .tab-header {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #eeeeee;
                margin-bottom: 20px;
                background: #ffffff;
                transition: all 0.3s ease;

                &.fixed {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    z-index: 1000;
                    margin-bottom: 0;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }

                .tab-item {
                    flex: 1;
                    text-align: center;
                    line-height: 44px;
                    font-size: 14px;
                    color: #999999;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    position: relative;
                    font-weight: normal;

                    &:hover {
                        color: #6b4d9a;
                    }

                    &.active {
                        color: #6b4d9a;
                        font-weight: bold;

                        &::after {
                            content: "";
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 2px;
                            background: #6b4d9a;
                        }
                    }
                }

                .tab-divider {
                    width: 1px;
                    height: 16px;
                    background: #eeeeee;
                    margin: 14px 0;
                    align-self: center;
                }
            }

            .tab-content {
                padding: 0 16px;

                .tab-panel {
                    margin-bottom: 16px;
                }
            }

            // 当tab固定时，为内容添加顶部间距
            &.tab-fixed {
                .tab-content {
                    padding-top: 64px; // tab高度 + 间距
                }
            }
        }

        .item-title {
            line-height: 28px;
            padding-left: 15px;
            font-size: 14px;
            font-weight: bold;
            color: #2d2d2d;
            border-left: 7px solid #6b4d9a;
        }

        .item-content {
            margin-top: 20px;

            p {
                margin-bottom: 15px;
                font-size: 10px;
                color: #2d2d2d;

                img {
                    width: 100%;
                    height: auto;
                }
            }
        }

        .item-table {
            margin-top: 20px;

            .table-title {
                display: flex;
                align-items: center;
                line-height: 35px;
                background: #6b4d9a;

                span {
                    flex: 1;
                    text-align: center;
                    font-size: 12px;
                    color: #ffffff;
                }
            }

            .table-content {
                display: flex;
                align-items: center;
                line-height: 35px;

                span {
                    flex: 1;
                    text-align: center;
                    font-size: 12px;
                    color: #333333;
                }
            }
        }

        .spec-list {
            .spec-item {
                padding: 10px;
                background: #eeeeee;
                margin-bottom: 0;

                &:nth-child(2n) {
                    background: transparent;
                }

                b {
                    margin-right: 10px;
                    font-size: 10px;
                    color: #2d2d2d;
                }
            }
        }

        // 买家秀tab内容样式
        .buyer-show-tab-content {
            .show-items {
                .show-item {
                    background: #ffffff;
                    border-radius: 8px;
                    margin-bottom: 16px;
                    padding: 12px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    position: relative;
                    overflow: hidden;
                    border: 1px solid #f0f0f0;

                    // 图片/视频区域
                    .media-content {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                        margin-bottom: 12px;

                        .media-item {
                            width: 100%;
                            cursor: pointer;
                            position: relative;

                            img {
                                width: 100%;
                                height: auto;
                                display: block;
                                border-radius: 6px;
                            }

                            // 统一角标样式
                            .media-badge {
                                position: absolute;
                                top: 8px;
                                right: 8px;
                                background: rgba(0, 0, 0, 0.6);
                                color: #ffffff;
                                padding: 4px 8px;
                                border-radius: 12px;
                                font-size: 12px;
                                z-index: 10;
                                display: flex;
                                align-items: center;
                                gap: 4px;
                            }
                        }

                        // 视频样式
                        .video-item {
                            position: relative;
                            border-radius: 6px;
                            overflow: hidden;

                            .video-player {
                                width: 100%;
                                height: auto;
                                display: block;
                                border-radius: 6px;
                            }
                        }

                        // 图片样式
                        .image-item {
                            border-radius: 6px;
                            overflow: hidden;
                        }
                    }

                    // 用户信息区域
                    .user-info {
                        display: flex;
                        align-items: center;
                        margin-bottom: 12px;

                        .avatar {
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            overflow: hidden;
                            margin-right: 12px;

                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }

                        .user-details {
                            flex: 1;

                            .user-name {
                                font-size: 14px;
                                font-weight: bold;
                                color: #333333;
                                margin-bottom: 2px;
                            }

                            .show-time {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                    }

                    // 文字内容
                    .show-text {
                        font-size: 14px;
                        color: #333333;
                        line-height: 1.5;
                    }
                }
            }

            .empty-state {
                text-align: center;
                padding: 60px 20px;

                .empty-icon {
                    font-size: 48px;
                    margin-bottom: 16px;
                }

                .empty-text {
                    font-size: 14px;
                    color: #999999;
                }
            }

            .load-more {
                text-align: center;
                padding: 20px 0;

                span {
                    display: inline-block;
                    padding: 8px 24px;
                    background: #6b4d9a;
                    color: #ffffff;
                    border-radius: 20px;
                    font-size: 14px;
                    cursor: pointer;
                    transition: all 0.3s ease;

                    &:hover {
                        background: #5a3f86;
                    }
                }
            }

            .loading {
                text-align: center;
                padding: 20px 0;
                color: #999999;
            }
        }
    }

    .choose-dialog {
        padding: 14px 0;

        .item-top {
            margin: 0 14px;
            padding: 0 0 7px 0;
            border-bottom: 1px solid #eeeeee;

            .p1 {
                font-size: 10px;
                color: #2d2d2d;
            }

            .p2 {
                margin-top: 20px;
                font-size: 14px;
                font-weight: bold;
                color: #2d2d2d;
            }

            .p3 {
                margin-top: 20px;
                display: flex;
                align-items: center;

                span {
                    font-size: 10px;
                    font-weight: bold;
                    color: #2d2d2d;
                }

                .red {
                    margin-left: auto;
                    color: #f54a4a;
                }
            }
        }

        .item-middle {
            padding: 0 14px;
            height: 300px;
            overflow-y: scroll;

            .list-wrapper {
                .list-item {
                    display: flex;
                    align-items: center;
                    margin-top: 14px;

                    .item-name {
                        max-width: 130px;
                        margin-right: auto;
                        padding: 5px 14px;
                        font-size: 10px;
                        color: #999999;
                        background: #eeeeee;
                        border-radius: 3px;
                    }

                    .item-count {
                        .van-stepper {
                            button {
                                width: 20px;
                                height: 23px;
                            }

                            input {
                                width: 30px;
                                height: 23px;
                            }
                        }
                    }

                    .item-price {
                        width: 70px;
                        text-align: right;
                        font-size: 10px;
                        color: #999999;
                    }
                }
            }
        }

        .item-bottom {
            margin: 14px 14px 0 14px;
            padding: 14px 0 0 0;
            border-top: 1px solid #eee;
        }
    }

    .add-success-dialog {
        padding: 14px;

        .item-image {
            width: 100%;
            height: 170px;
            background-repeat: no-repeat !important;
            background-size: cover !important;
            background-position: center !important;
            border-radius: 3px;
        }

        .item-title {
            display: flex;
            align-items: center;
            margin-top: 14px;

            .title-left {
                line-height: 25px;
                font-size: 14px;
                font-weight: bold;
                color: #2d2d2d;
            }

            .title-right {
                min-width: 110px;
                margin-left: auto;
                text-align: right;

                i {
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 20px;
                    color: #88cf65;
                }

                span {
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 3px;
                    font-size: 14px;
                    color: #88cf65;
                }
            }
        }

        .item-info {
            margin: 10px 0 0 0;

            p {
                line-height: 20px;
                display: flex;

                span {
                    font-size: 10px;
                    font-weight: bold;
                    color: #2d2d2d;
                }

                .s1 {
                    margin-left: auto;
                    color: #f54a4a;
                }

                .s2 {
                    margin-left: auto;
                    color: #6b4d9a;
                }
            }
        }

        .item-button {
            margin: 14px 0 0 0;
        }
    }

    .van-dialog {
        border-radius: 5px;
    }
}
</style>
